import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';
import { AuthGuard, OnboardingGuard } from 'src/auth/guard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Dashboard
const DashboardIndexPage = lazy(() => import('src/pages/dashboard'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
// PRODUCT
const ListingListPage = lazy(() => import('src/pages/listing/list'));
const ListingCreatePage = lazy(() => import('src/pages/listing/new'));
const ListingEditPage = lazy(() => import('src/pages/listing/edit'));
const ListingArchivedPage = lazy(() => import('src/pages/listing/archived'));
const BulkCrossListSetupPage = lazy(() => import('src/pages/listing/bulk-cross-list'));
const BulkCrossListBatchPage = lazy(() => import('src/pages/listing/bulk-cross-list-batch'));
const MergeSetupPage = lazy(() => import('src/pages/listing/merge'));
const MergeBatchPage = lazy(() => import('src/pages/listing/merge-batch'));
// Management
const StoresPage = lazy(() => import('src/pages/management/stores'));
const StorePreferencesPage = lazy(() => import('src/pages/management/store-preferences'));
const ShippingProfilesPage = lazy(() => import('src/pages/management/shipping-profiles'));
// Studio
const TemplateListPage = lazy(() => import('src/pages/studio/templates'));
const TemplateCreatePage = lazy(() => import('src/pages/studio/template-new'));
const TemplateEditPage = lazy(() => import('src/pages/studio/template-edit'));
// Account
const AccountPage = lazy(() => import('src/pages/account/AccountPage'));
// What's new
const ChangelogPage = lazy(() => import('src/pages/changelog'));
// Admin
const AdminDashboardPage = lazy(() => import('src/pages/admin/dashboard'));

// ----------------------------------------------------------------------

export const dashboardRoutes =
{
  path: '/',
  element: (
    <AuthGuard>
      <OnboardingGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </OnboardingGuard>
    </AuthGuard>
  ),
  children: [
    { path: '/', element: <DashboardIndexPage /> },
    { path: 'dashboard', element: <OverviewEcommercePage /> },
    { path: "stores", element: <StoresPage /> },
    { path: "store-preferences", element: <StorePreferencesPage /> },
    { path: "shipping-profiles", element: <ShippingProfilesPage /> },
    { path: "account", element: <AccountPage /> },
    { path: 'changelog', element: <ChangelogPage /> },
    {
      path: 'listing',
      children: [
        { element: <ListingListPage />, index: true },
        { path: 'list', element: <ListingListPage /> },
        { path: 'new', element: <ListingCreatePage /> },
        { path: ':id/edit', element: <ListingEditPage /> },
        { path: 'archived', element: <ListingArchivedPage /> },
        { path: 'bulk-cross-list', element: <BulkCrossListSetupPage /> },
        { path: 'bulk-cross-list/batch/:batchId', element: <BulkCrossListBatchPage /> },
        { path: 'merge', element: <MergeSetupPage /> },
        { path: 'merge/batch/:batchId', element: <MergeBatchPage /> },
      ],
    },
    {
      path: 'studio',
      children: [
        {
          path: 'templates',
          children: [
            { element: <TemplateListPage />, index: true },
            { path: 'new', element: <TemplateCreatePage /> },
            { path: ':id/edit', element: <TemplateEditPage /> },
          ],
        },
      ],
    },
    {
      path: 'admin',
      children: [
        { path: 'dashboard', element: <AdminDashboardPage /> },
      ],
    },
  ],
};


